import React, { useState, useCallback } from 'react';
import {
    Col,
    Button,
    FormGroup,
    Label,
    Form,
    Modal,
    ModalHeader,
    ModalBody
} from 'reactstrap';
import { useForm } from 'react-hook-form';
import InputMask from 'react-input-mask';
import * as Yup from 'yup';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../Context/Auth/AuthContext';
import UserRoles from '../../enums/UserRoles';

const schema = Yup.object().shape({
    email: Yup.string().email('Email invalid!').required('Email is required!'),
    name: Yup.string().required('Name is required!'),
    phone: Yup.string().required('Phone is required!'),
});

export default function ModalEditInfo(props) {
    const { modalEditInfo, toggleModalEditInfo, id, loadCallback, member } = props;

    const { toggleLoading } = useAuth();
    const { register, handleSubmit, errors, reset } = useForm({
        validationSchema: schema,
    });
    const [isUpdating, setIsUpdating] = useState(false);

    const onSubmitEditInfo = useCallback(async (data) => {
        const newEmail = data.email;
        const newName = data.name;
        const newPhone = data.phone;

        setIsUpdating(true);
        toggleLoading(true);

        api.patch(`/ro.team.changeUserInfo/${id.id}`, {
            type: UserRoles.RECEIVER,
            idMember: member.id,
            newEmail: newEmail,
            newName: newName,
            newPhone: newPhone
        })
            .then((response) => {
                toast.success(`Senior info changed!`);
                reset(response);
                if (loadCallback) loadCallback();
                toggleModalEditInfo();
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
                setIsUpdating(false);
            });
    }, [setIsUpdating, toggleLoading, id, member, toggleModalEditInfo, reset, loadCallback]);

    return (
        <Modal isOpen={modalEditInfo} toggle={toggleModalEditInfo}>
            <ModalHeader toggle={toggleModalEditInfo}>
                Edit Senior Info
            </ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup row>
                        <Label for="name" sm={2}>
                            Name
                        </Label>
                        <Col sm={10}>
                            <input
                                type="text"
                                name="name"
                                id="name"
                                ref={register}
                                defaultValue={member && member.name}
                                className="form-control" 
                            />
                            {errors.name && (
                                <p className="error-validation-left">
                                    { errors.name.message }
                                </p>
                            )}
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="email" sm={2} >
                            Email
                        </Label>
                        <Col sm={10}>
                            <input
                                type="email"
                                name="email"
                                id="email"
                                ref={register}
                                defaultValue={member && member.email}
                                className="form-control" 
                            />
                            {errors.email && (
                                <p className="error-validation-left">
                                    { errors.email.message }
                                </p>
                            )}
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="phone" sm={2} >
                            Phone
                        </Label>
                        <Col sm={10}>
                            <InputMask
                                mask="(999) 999-9999"
                                name="phone"
                                id="phone"
                                inputRef={register}
                                className="form-control"
                                defaultValue={member && member.phone}
                            />
                            {errors.phone && (
                                <p className="error-validation-left">
                                    { errors.phone.message }
                                </p>
                            )}
                        </Col>
                    </FormGroup>
                    <FormGroup check row>
                        <Col sm={{ size: 15, offset: 2 }} >
                            <Button
                                onClick={handleSubmit(onSubmitEditInfo)}
                                color="info"
                                disabled={isUpdating === true}
                            >
                                Edit
                            </Button>
                            <Button
                                onClick={toggleModalEditInfo}
                                color="secondary"
                                className="ml-2"
                            >
                                Cancel
                            </Button>
                        </Col>
                    </FormGroup>
                </Form>
            </ModalBody>
        </Modal>
    );
}
